import { GeneralModel } from "./general.model";
import { Customer } from "./customer.model";

export class CustomerPaymentTo extends GeneralModel {
    customerId: number;
    paymentToCustomerId: number;

    customer: Customer;
    paymentToCustomer: Customer;
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/customerPaymentTo.model.ts